import React from 'react';
import { Page, Text, View, Image } from '@react-pdf/renderer';
import dateFormat from 'dateformat';

import hgsdLogo from '../../black-textHGSDlogo400px.png';
import ftBendLogo from '../../fbsd_logo_clr_rgb.png';

function getAmPm(time) {
  if (time >= 12) {
    return 'AM';
  } else {
    return 'PM';
  }
}

function getHearingTime(hearing) {
  console.log('hearing:');
  console.log(hearing);
  if (hearing && hearing.HEARING_TIME) {
    const time = hearing.HEARING_TIME.toString();
    if (time.length <= 3) {
      return `${time.substr(0, 1)}:${time.substr(1, 2)} ${getAmPm(
        hearing.HEARING_TIME
      )}`;
    } else {
      return `${time.substr(0, 2)}:${time.substr(2, 2)} ${getAmPm(
        hearing.HEARING_TIME
      )}`;
    }
  } else {
    return '';
  }
}

function getHearingDate(hearing) {
  if (hearing && hearing.HEARING_DATE) {
    const date = new Date(hearing.HEARING_DATE);
    console.log('date: ', date);
    return dateFormat(new Date(hearing.HEARING_DATE), 'mm/dd/yyyy', true);
  }
  return '';
}

function get17DaysHearingDate(hearing) {
  if (hearing && hearing.HEARING_DATE) {
    const nextDate = new Date(hearing.HEARING_DATE);
    nextDate.setDate(nextDate.getDate() + 17);
    return dateFormat(nextDate, 'mm/dd/yyyy', true);
  } else {
    return '';
  }
}

function get8DaysHearingDate(hearing) {
  if (hearing && hearing.HEARING_DATE) {
    const nextDate = new Date(hearing.HEARING_DATE);
    nextDate.setDate(nextDate.getDate() + 8);
    return dateFormat(nextDate, 'mm/dd/yyyy', true);
  } else {
    return '';
  }
}

export default function AppendixC({ styles, hearing, year, month, footer }) {
  return (
    <Page size='A4'>
      <View style={styles.pageTitle}>
        <Text style={styles.pageTitle}></Text>
      </View>
      <View style={styles.document}>
        <View style={[styles.row, styles.borderBottom]}>
          <Image
            src={window.config.client === 'FT-BEND' ? ftBendLogo : hgsdLogo}
            style={styles.logo}
          />
          <Text style={styles.logoLabel}>Appendix C</Text>
        </View>
        <View style={[styles.row, styles.borderBottom]}>
          <Text style={styles.logo} />
          <Text style={styles.logoLabel}>Summary</Text>
        </View>
        <View style={styles.section}>
          <Text>
            At approximately {getHearingTime(hearing)} on{' '}
            {getHearingDate(hearing)}, public hearing was convened at the office
            of the Subsidence District at{' '}
            {window.config.client === 'FT-BEND'
              ? '301 Jackson Street, Suite 639, Richmond, TX'
              : '1660 West Bay Area Blvd., Friendswood, Harris County, Texas.'}
          </Text>
        </View>
        <View style={styles.section}>
          <Text>
            It was verified that proper notices had been issued in accordance
            with the District's enabling legislation, the Rules of the District,
            and the Open Meetings Act.
          </Text>
        </View>
        <View style={styles.section}>
          <Text>
            After opening the hearings and explaining some procedural steps, the
            Hearing Examiner administered the oath to those in the audience who
            expected to testify. It was subsequently verified that each person
            who testified had taken the oath.
          </Text>
        </View>
        <View style={styles.section}>
          <Text>
            After hearing testimony and introducing into the record other
            evidence, the Hearing Examiner held the record open until{' '}
            {window.config.client === 'FT-BEND'
              ? `5:00 p.m., ${get8DaysHearingDate(hearing)}`
              : `${getHearingTime(hearing)}, ${get17DaysHearingDate(hearing)}`}
            .
          </Text>
        </View>
        <View style={styles.section}>
          <Text>
            A list of those applicants heard is shown in the Table of Contents.
          </Text>
        </View>
        <View style={styles.section}>
          <Text>
            The report deals with each applicant individually. The District Plan
            divides the District into{' '}
            {window.config.client === 'FT-BEND' ? 'two' : 'Three'} Regulatory
            Areas. For ease of identification, the Area in which the well(s) is
            located is noted on the first page of the applicant's report.
          </Text>
        </View>
      </View>
      <View fixed style={styles.footer}>
        {/* <Text style={styles.data}>{footer}</Text> */}
        <Text
          style={styles.data}
          render={({ pageNumber, totalPages }) =>
            `${footer} (${pageNumber}/${totalPages})`
          }
        />
      </View>
    </Page>
  );
}
